// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileAvatar_avatar__QfEiv","avatarLoaded":"ProfileAvatar_avatarLoaded__QNSj3"};